import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logobg.png";
import instaIcon from "../assets/instagram-icon.png";
import linkedinIcon from "../assets/linkedin-icon.png";

const Footer = () => {
  return (
    <>
      <style>{`
        .footer {
          background: #DCF6C6;
          padding: 80px 20px 30px;
        }

        .footer-container {
          max-width: 1100px;
          margin: auto;
        }

        .footer-top {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1fr;
          gap: 40px;
        }

        .footer-logo img {
          height: 80px;
          margin-bottom: 10px;
        }

        .footer-desc {
          color: #3f4d43;
          font-size: 15px;
          line-height: 1.7;
          margin-bottom: 20px;
        }

        .socials {
          display: flex;
          gap: 15px;
        }

        .social {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          background: #97E074;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.3s;
        }

        .social img {
          width: 20px;
        }

        .social:hover {
          transform: scale(1.1);
        }

        .footer-col h4 {
          margin-bottom: 15px;
          color: #1e2d23;
        }

        .footer-col ul {
          list-style: none;
          padding: 0;
        }

        .footer-col li {
          margin-bottom: 10px;
          font-size: 14px;
        }

        .footer-col a {
          text-decoration: none;
          color: #3f4d43;
        }

        .footer-col a:hover {
          color: #000;
        }

        .contact p,
        .contact a {
          display: block;
          margin-bottom: 12px;
          font-size: 14px;
          color: #3f4d43;
          text-decoration: none;
        }

        .footer-bottom {
          border-top: 1px solid rgba(0,0,0,0.1);
          margin-top: 50px;
          padding-top: 20px;

          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;

          font-size: 14px;
        }

        .footer-bottom a {
          text-decoration: none;
          font-weight: 500;
          color: #1e2d23;
        }

        @media (max-width: 900px) {
          .footer-top {
            grid-template-columns: 1fr;
          }

          .footer-bottom {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-container">

          <div className="footer-top">

            {/* LEFT */}
            <div>
              <div className="footer-logo">
                <img src={logo} alt="Logo" />
              </div>

              <div className="footer-desc">
                We provide expert services in ITR filing, GST compliance,
                bookkeeping, and tax planning to help your business grow
                with confidence.
              </div>

              <div className="socials">
                <a
                  href="https://www.instagram.com/welthan_official?igsh=MWU4djI0cW90cjU1dQ=="
                  target="_blank"
                  rel="noreferrer"
                  className="social"
                >
                  <img src={instaIcon} alt="Instagram" />
                </a>

                <a
                  href="https://www.linkedin.com/in/welthan-finance-services-ashish-tiwari-137103357"
                  target="_blank"
                  rel="noreferrer"
                  className="social"
                >
                  <img src={linkedinIcon} alt="LinkedIn" />
                </a>
              </div>
            </div>

            {/* OTHER PAGES */}
            <div className="footer-col">
              <h4>Other Pages</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* SUPPORT */}
            <div className="footer-col">
              <h4>Support Center</h4>
              <ul>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
              </ul>
            </div>

            {/* CONTACT */}
            <div className="footer-col contact">
              <h4>Contact Us</h4>
              <p>A/251 Barra - 6, Kanpur</p>

              <a href="mailto:welthanfinance@gmail.com">
                welthanfinance@gmail.com
              </a>

              <a href="tel:+919151622122">
                +91 9151622122
              </a>

              <a href="tel:+919454332268">
                +91 9454332268
              </a>
            </div>

          </div>

          {/* BOTTOM */}
          <div className="footer-bottom">
            <div>
              Powered by{" "}
              <a href="https://codesaarthi.com" target="_blank" rel="noreferrer">
                Code Saarthi
              </a>
            </div>

            <div>
              Copyright © 2025 All rights reserved by Welthan
            </div>
          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;